import React, { createContext, useContext } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en.json';
import baTranslation from './locales/ba.json';


const resources = {
    en: {
        translation: enTranslation,
    },
    ba: {
        translation: baTranslation,
    },

};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'fr',
        interpolation: {
            escapeValue: false,
        },
    });

export const I18nContext = createContext();

export function useI18n() {
    return useContext(I18nContext);
}

export const I18nProvider = ({ children }) => {
    return (
        <I18nContext.Provider value={{ t: i18n.t }}>
            {children}
        </I18nContext.Provider>
    );
};
